import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-multiple',
  templateUrl: './delete-multiple.component.html',
  styleUrls: ['./delete-multiple.component.scss']
})
export class DeleteMultipleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
